<template>
<div>
    <Slide :pageOption="pageOption" /> 
    <div class="mainSite" v-if="category">  
        <Content v-if="!category.extra" :category="category"   />
        <TestContest v-if="category.extra=='TestContest'" :category="category"    />
    </div>
</div>
</template>

<script>
import Content from '@/views/Content/Content'
import TestContest from '@/views/TestContest/TestContest'
export default {

    components: {
        Content,
        TestContest
    },

    data: () => ({ 
        category: null,
        pageOption: null,

    }),

    computed: {
        sub_slug() {
            return this.$route.params.sub_slug;
        },
        category_slug() {
            return this.$route.params.category_slug;
        }, 
    },

    watch: {

    },
    methods: {

        getCategory() {
            let data = {}
            data.category_slug = this.category_slug
            data.sub_slug = this.sub_slug
            const formData = this.$formData(
                data
            );
            let url = "category/one";
            let $vm = this;
            this.$API
                .post(url, this.formData(formData))
                .then(function (res) {
                    $vm.checkApi(res);
                    $vm.category = res.data.category
                    $vm.pageOption = res.data.pageOption
                  

                })
                .catch(function (error) {
                    console.log(error);
                });

        },

    },
    created() {

        this.getCategory()

        this.$CURRENT_CONTENT_ID = null
        this.$MEMBER_ONLY_TEXT = null

    },
};
</script>
